module.exports = __webpack_public_path__ + "static/media/softwareBg.11bda6b4.jpg";